import type { RouteRecordRaw } from 'vue-router'

import authMiddleware from '@/router/middleware/authMiddleware'
import guestMiddleware from '@/router/middleware/guestMiddleware'

export default <RouteRecordRaw[]>[
    /* ------------ */
    /* Start Layout */
    /* ------------ */
    {
        path: '/',
        component: async () => import('@/layouts/StartLayout.vue'),
        meta: { middleware: [guestMiddleware] },
        children: [
            { path: '/', name: 'Inicio', component: async () => import('@/pages/WelcomePage.vue') },
            /* ------------ */
            /* Login Routes */
            /* ------------ */
            { path: '/login', name: 'Login', component: async () => import('@/pages/auth/LoginPage.vue') },
        ],
    },
    /* ------------- */
    /*  Main Layout  */
    /* ------------- */
    {
        path: '/app',
        component: async () => import('@/layouts/MainLayout.vue'),
        meta: { middleware: [authMiddleware] },
        children: [
            { path: '/experimental', name: 'Experimental', component: async () => import('@/pages/TestPage.vue') },
            { path: '/dashboard', name: 'Dashboard', component: async () => import('@/pages/DashboardPage.vue') },
            { path: '/rendimiento', name: 'Rendimiento', component: async () => import('@/pages/rendimiento/RendimientoPage.vue') },
            { path: '/simular', name: 'Simular', component: async () => import('@/pages/simular/SimularPage.vue') },
            { path: '/docs/formular', name: 'HowToFormular', component: async () => import('@/pages/docs/HowToFormular.vue') },
            { path: '/config', name: 'Config', component: async () => import('@/pages/config/ConfigPage.vue') },
        ],
    },
    /* Error Routes */
    {
        path: '/error',
        component: async () => import('@/layouts/StartLayout.vue'),
        children: [{ path: '/:pathMatch(.*)*', name: '404', component: async () => import('@/pages/errors/ErrorPage404.vue') }],
    },
]
